import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import "./PerfilPublico.css";

export default function PerfilPublico() {
  const { alunoId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get(`/perfil-publico/${alunoId}/`)
      .then((res) => setData(res.data))
      .catch((err) => console.error(err));
  }, [alunoId]);

  if (!data) return <p>Carregando…</p>;

  return (
    <div>

      {/* HEADER FIXO */}
      <div className="public-header shadow-sm">
        <img
          src="/logo-aristo-branco.png"
          alt="Aristo"
          className="public-header-logo"
        />
      </div>

      <div className="container mt-5 pt-5">

        {/* FOTO E NOME */}
        <div className="text-center mb-4">
          <img
            src={data.foto_perfil || `https://ui-avatars.com/api/?name=${encodeURIComponent(data.nome)}&size=150&background=6366f1&color=fff&bold=true`}
            alt="Foto do aluno"
            className="public-foto-perfil"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(data.nome)}&size=150&background=6366f1&color=fff&bold=true`;
            }}
          />
          <h2 className="mt-3">{data.nome}</h2>
          {data.curso && <p className="text-muted">{data.curso}</p>}
        </div>

        {/* PERFORMANCE */}
        <div className="card p-3 mb-4 shadow-sm">
          <h4 className="mb-3">Performance pública</h4>

          <p><strong>Total de check-ins:</strong> {data.total_checkins}</p>

          {/* Emojis totais */}
          <div className="mb-3">
            <strong>Histórico:</strong>
            <div className="emoji-line">
              {data.emojis_total.slice(0, 20).map((e, idx) => (
                <span key={idx} className="emoji">{e}</span>
              ))}
              {data.emojis_total.length > 20 && (
                <span className="emoji text-muted">…</span>
              )}
            </div>
          </div>

          {/* Hoje */}
          <div className="mb-3">
            <strong>Hoje:</strong>
            <div className="emoji-line">
              {data.emojis_hoje.map((e, idx) => (
                <span key={idx} className="emoji">{e}</span>
              ))}
            </div>
          </div>

          {/* Semana */}
          <div>
            <strong>Semana:</strong>
            <div className="emoji-line">
              {data.emojis_semana.map((e, idx) => (
                <span key={idx} className="emoji">{e}</span>
              ))}
            </div>
          </div>
        </div>

        {/* BADGES */}
        <div className="card p-3 mb-4 shadow-sm">
          <h4 className="mb-3">Badges conquistadas</h4>

          {data.badges.length === 0 && <p>Nenhuma badge ainda.</p>}

          <div className="d-flex gap-2 flex-wrap">
            {data.badges.map((b, idx) => (
                <span
                key={idx}
                className="badge bg-primary"
                style={{ fontSize: "1rem" }}
                >
                {b.emoji} {b.nome}
                </span>
            ))}
            </div>
        </div>
      </div>
    </div>
  );
}
